import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { Typography } from '@mui/material'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import type { NavItem } from '../../config/useNavConfig'
import styles from './NavDropdown.module.scss'

interface NavDropdownProps {
  title: string
  size?: 'large' | 'small'
  subItems: NavItem[]
}

const NavDropdown = ({ title, size, subItems }: NavDropdownProps) => {
  const location = useLocation()
  const [dropdownIsOpen, setDropdownIsOpen] = useState<boolean>(false)

  // This will only be true for perks proper, but might come in handy if we build out this dropdown
  const active = subItems.some(
    ({ link }) => location.pathname === link.split('?')[0],
  )

  return (
    <div
      className={styles.navDropdownWrapper}
      onMouseEnter={() => setDropdownIsOpen(true)}
      onMouseLeave={() => {
        setDropdownIsOpen(false)
      }}
    >
      <NavDropdownLink
        active={active}
        dropdownIsOpen={dropdownIsOpen}
        title={title}
        size={size}
      />
      {dropdownIsOpen && <NavDropdownMenu subItems={subItems} />}
    </div>
  )
}

interface NavDropdownLinkProps {
  active: boolean
  title: string
  dropdownIsOpen: boolean
  size?: 'large' | 'small'
}

const NavDropdownLink = ({
  active,
  title,
  dropdownIsOpen,
  size = 'large',
}: NavDropdownLinkProps) => (
  <div className={`${styles.navDropdownLink} ${active ? styles.active : ''}`}>
    <Typography variant={size === 'small' ? 'body1' : 'h6'}>
      <span className={styles.navDropdownLinkText}>{title}</span>
      {dropdownIsOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
    </Typography>
  </div>
)

export const NavDropdownMenu = ({ subItems }: { subItems: NavItem[] }) => (
  <div className={styles.navDropdownMenu}>
    {subItems.map((subItem) => {
      return (
        subItem.isVisibleForUserRole && (
          <NavDropdownMenuItem
            link={subItem.link}
            title={subItem.title}
            key={subItem.link}
          />
        )
      )
    })}
  </div>
)

interface NavDropdownMenuItemProps {
  link: string
  title: string
}

const NavDropdownMenuItem = ({ link, title }: NavDropdownMenuItemProps) => {
  return (
    <a href={link} className={styles.navDropdownMenuItem}>
      {title}
    </a>
  )
}

export default NavDropdown
